import * as React from 'react';

// HORO-10326: collapsed-sidebar login affordance per Figma 1060:12906 —
// a person silhouette (head circle + shoulders arch), not the door /
// arrow glyph used for logout. White stroke matches the rest of the
// collapsed icons stack.
const LoginIcon = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" {...props}>
        <circle cx={12} cy={8} r={4} stroke="#FFFFFF" strokeWidth={1.5} />
        <path stroke="#FFFFFF" strokeWidth={1.5} strokeLinecap="round" d="M4 21c0-3.866 3.582-7 8-7s8 3.134 8 7" />
    </svg>
);

export default LoginIcon;
